import { RegulatoryPraDetailsModel } from './regulatory-pra-details.model';
import { PraImpactAnalysesModels } from './pra-impact-analyses.models';

export class RegulatoryPraModel {
  adoptionPurpose?: string;
  authorizedUnit?: string;
  changeFile?: any[];
  createdAt?: string;
  deletedAt?: string;
  impactAnalyses?: PraImpactAnalysesModels[];
  necessityJustification?: string;
  order?: number;
  regActKindTitle?: string;
  regActProject?: RegulatoryPraDetailsModel[];
  regActTypeTitle?: string;
  startDate?: string;
  title?: string;
  updatedAt?: string;
  regPlanItemId?: string;
  viewCount?: number;
  plan: { edrpou?: number } = {};

  constructor(item: any) {
    this.adoptionPurpose = item.adoptionPurpose;
    this.authorizedUnit = item.authorizedUnit;
    this.changeFile = item.changeFile;
    this.regActKindTitle = item.regActKindTitle;
    this.regActTypeTitle = item.regActTypeTitle;
    this.startDate = item.startDate;
    this.deletedAt = item.deletedAt;
    this.impactAnalyses = item.impactAnalyses?.map(
      (analys: any) => new PraImpactAnalysesModels(analys),
    );
    this.necessityJustification = item.necessityJustification;
    this.regActProject =
      item.regActProject?.map(
        (project: any) => new RegulatoryPraDetailsModel(project),
      ) || [];
    this.plan = item.plan || {};

    this.title = item.title;
    this.updatedAt = item.updatedAt;
    this.order = item.order;
    this.createdAt = item.createdAt;
    this.regPlanItemId = item.regPlanItemId;
    this.viewCount = item.viewCount;
  }

  static fromJson(json: any): RegulatoryPraModel {
    return new RegulatoryPraModel(json);
  }
}
